export default class TopNavigation {
    constructor(elm) {
        let didScroll = false;
        let lastScrollTop = 0;
        let delta = 5;
        let header = elm;
        let megaMenuExpanders = elm.querySelectorAll('[data-opens-mega-menu]');
        let megaMenues = elm.querySelectorAll('[data-mega-menu]');
        var welcomeScreenScrolled = false;
        var welcomeHeight = header.offsetTop;
        var body = document.body;

        window.onscroll = () => {
            const st = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            var welcomeScreenActive = body.classList.contains('welcome-screen-active');
            if (welcomeScreenActive) {
                if (st > welcomeHeight) {
                    body.classList.add('welcome-screen-scrolled');
                    welcomeScreenScrolled = true;
                } else {
                    body.classList.remove('welcome-screen-scrolled');
                    welcomeScreenScrolled = false;
                    header.classList.remove('scrolled');
                    header.classList.remove('nav-up');
                    header.classList.remove('nav-down');
                }
            }

            if (!welcomeScreenActive || welcomeScreenScrolled) {
                header.classList.toggle('scrolled', st > 0);
                didScroll = true;
            }
        };

        setInterval(() => {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        var dataHref = elm.querySelectorAll('[data-href]')
        dataHref.forEach(x => x.onclick = () => {
            if (window.innerWidth < 992) {
                document.location = x.dataset.href;
            }
        });

        header.querySelector('.burger-menu').addEventListener('click', e => {
            e.preventDefault();
            var open = document.body.classList.contains('mobile-menu-open');
            document.body.classList.toggle('mobile-menu-open', !open);
            if (open) {
                megaMenues.forEach(x => x.classList.remove('mega-menu--active'))
            }
        });

        const checkScrollPosition = () => {
            if (document.documentElement.scrollTop > 0) {
                document.querySelector('header').classList.add('scrolled');
                document.querySelector('header').classList.add('nav-up');
                document.querySelector('header').classList.add('nav-down');
                document.body.classList.add('body-nav-up');
            }
        }

        checkScrollPosition();

        const removeUnderline = () => {
            const underline = elm.querySelector('.nav-link__underline');
            if (underline) {
                underline.parentNode.removeChild(underline);
            }
        }

        const addUnderline = (targetListItem) => {
            if (document.body.offsetWidth > 992) {
                const underline = document.createElement('span');
                underline.classList.add('nav-link__underline');
                targetListItem.appendChild(underline);
            }
        }

        const removeSelectedSubmenu = () => {
            removeUnderline();
            const selectedSubmenu = elm.querySelector('.nav-link--selected');
            const megaMenuContainer = elm.querySelector('.mega-menu__container--expanded');
            const activeSubmenuLists = elm.querySelectorAll('.submenu-list--active');
            if (selectedSubmenu && megaMenuContainer) {
                selectedSubmenu.classList.remove('nav-link--selected');
                megaMenuContainer.classList.remove('mega-menu__container--expanded');
                megaMenuContainer.classList.remove('mega-menu__container--hidden');
            }
            if (activeSubmenuLists && activeSubmenuLists.length > 0) {
                activeSubmenuLists.forEach(item => {
                    item.classList.remove('submenu-list--active');
                })
            }
            const fullHeightMenu = elm.querySelector('.full-height');
            if (fullHeightMenu) {
                fullHeightMenu.classList.remove('full-height');
            }
            const megaMenuInnerFullHeight = elm.querySelector('.mega-menu__inner--full-height');
            const activeMegaMenuFullHeight = elm.querySelector('.mega-menu--active--full-height');
            if (megaMenuInnerFullHeight) {
                megaMenuInnerFullHeight.classList.remove('mega-menu__inner--full-height');
            }
            if (activeMegaMenuFullHeight) {
                activeMegaMenuFullHeight.classList.remove('mega-menu--active--full-height');
            }
        }


        megaMenuExpanders.forEach(clicked => clicked.onclick = (event) => {
            const prevActiveMenu = elm.querySelector('.active-menu');
            let targetListItem;
            if (event.target.classList.contains("nav-link") || event.target.classList.contains("nav-item__chevron")) {
                targetListItem = event.target.parentNode;
            } else if (event.target.classList.contains("nav-item")) {
                targetListItem = event.target;
            } else if (event.target.parentNode.classList.contains("nav-item__chevron")) {
                targetListItem = event.target.parentNode.parentNode;
            }
            if (prevActiveMenu && targetListItem === prevActiveMenu) {
                prevActiveMenu.classList.remove('active-menu');

                removeSelectedSubmenu();
            } else {
                if (prevActiveMenu) {
                    prevActiveMenu.classList.remove('active-menu');
                    removeSelectedSubmenu();
                }

                if (targetListItem.classList.contains("active-menu")) {
                    targetListItem.classList.remove('active-menu');
                    removeSelectedSubmenu();
                } else {
                    targetListItem.classList.add('active-menu');
                    addUnderline(targetListItem);
                }
            }
            elm.querySelector(`[data-mega-menu="${clicked.dataset.opensMegaMenu}"]`).classList.toggle('mega-menu--active');
            megaMenues.forEach(others => { if (others.dataset.megaMenu != clicked.dataset.opensMegaMenu) { others.classList.remove('mega-menu--active') } })
        });

        const scrollToSubmenuTop = () => {
            if (document.body.offsetWidth > 991) {
                const activeMenu = elm.querySelector('.mega-menu--active');
                const inner = activeMenu.querySelector('.mega-menu__inner');
                inner.scrollTop = 0;
            }
        }

        var submenuExpanders = elm.querySelectorAll('[data-opens-submenu-list]');
        var submenues = elm.querySelectorAll('[data-submenu-list]');
        submenuExpanders.forEach(clicked => clicked.onclick = () => {
            scrollToSubmenuTop();
            elm.querySelector(`[data-submenu-list="${clicked.dataset.opensSubmenuList}"]`).classList.toggle('submenu-list--active');
            clicked.closest('.mega-menu__container').classList.add('mega-menu__container--expanded');

            if (clicked.classList.contains('nav-link--selected')) {
                submenuExpanders.forEach(y => y.classList.remove('nav-link--selected'));
                const expandedMenu = elm.querySelector('.mega-menu__container--expanded');
                if (expandedMenu) {
                    expandedMenu.classList.remove('mega-menu__container--expanded');
                }
            } else {
                submenuExpanders.forEach(y => y.classList.remove('nav-link--selected'));
                // If the clicked menu was already selected, don't add the selected class again
                clicked.classList.add('nav-link--selected');
            }

            submenues.forEach(others => {
                if (others.dataset.submenuList != clicked.dataset.opensSubmenuList) {
                    others.classList.remove('submenu-list--active');
                }
            })

            // In mobile view, if the sublink list (3rd level) is visible, we should set the mega-menu__container--expanded to 100vh and overflow hidden
            const justExpandedMenu = elm.querySelector('.mega-menu__container--expanded');
            if (document.body.offsetWidth < 992 && justExpandedMenu) {
                justExpandedMenu.classList.add('mega-menu__container--hidden');
            }
        });

        elm.querySelectorAll('[data-close-mega-menu]').forEach(x => x.onclick = () => {
            megaMenues.forEach(y => y.classList.remove('mega-menu--active'));
            elm.querySelectorAll('.active-menu').forEach(x => x.classList.remove('active-menu'));

        });

        elm.querySelectorAll('[data-close-submenu-list]').forEach(x => x.onclick = () => {
            submenues.forEach(y => setTimeout(() => { y.classList.remove('submenu-list--active') }, window.innerWidth > 992 ? 0 : 300));
            submenues.forEach(y => setTimeout(() => {
                y.classList.remove('submenu-list--active');
            }, window.innerWidth > 992 ? 0 : 300));

            x.closest('.mega-menu__container').classList.remove('mega-menu__container--expanded');
            submenuExpanders.forEach(y => y.classList.remove('nav-link--selected'));
            const hiddenMegaMenuContainer = elm.querySelector('.mega-menu__container--hidden');
            if (hiddenMegaMenuContainer) {
                hiddenMegaMenuContainer.classList.remove('mega-menu__container--hidden');
            }
        });

        window.addEventListener('click', x => {
            if (!x.target.closest('.header')) {
                megaMenues.forEach(others => { others.classList.remove('mega-menu--active') })
            }
        });

        function hasScrolled() {
            const st = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

            var realDelta = document.querySelector('.mega-menu--active') ? 250 : delta;
            if (Math.abs(lastScrollTop - st) <= realDelta) return;

            header.classList.toggle('nav-down', (st > lastScrollTop && st));
            header.classList.toggle('nav-up', (st > lastScrollTop && st));
            document.body.classList.toggle('body-nav-up', (st > lastScrollTop && st));

            lastScrollTop = st;

            megaMenues.forEach(others => {
                others.classList.remove('mega-menu--active');
                removeUnderline()
                const activeListItem = elm.querySelector('.active-menu');
                if (activeListItem) {
                    activeListItem.classList.remove('active-menu');
                }
            })
        }
    }
}
